import './index.css'
import { Col, List, Row, Tooltip, Typography } from 'antd'
import { dateFormatter } from 'utils/dateFormatter'
import CommentForm from './components/CommentForm'
import { formatCommentAge } from './formatCommentAge'
import type { CommentsProps } from './types'

/**
 * Presents one configured custom-workflow comments field. History remains
 * visible independently of whether comment creation is available.
 */
export default function Comments({
  canCreate,
  comments,
  fieldId,
  name,
  onCommentAdded,
  recordId,
  rowCreate,
}: CommentsProps) {
  const now = new Date()
  const chronologicalComments = [...comments].sort(
    ({ createdDate: a }, { createdDate: b }) =>
      new Date(a).getTime() - new Date(b).getTime()
  )

  return (
    <div className="workflow-record-comments">
      <Typography.Title level={5} style={{ marginBottom: 10 }}>
        {name}
      </Typography.Title>
      {chronologicalComments.length > 0 && (
        <List
          dataSource={chronologicalComments}
          renderItem={(
            {
              createdById,
              createdByMail,
              createdByUsername,
              createdDate,
              text,
            },
            index
          ) => (
            <List.Item
              className="workflow-record-comment"
              key={`${createdById}-${createdDate}-${text}-${index}`}
            >
              <Row align="top" gutter={8} wrap={false}>
                <Col>
                  <Tooltip title={createdByMail}>
                    <Typography.Text strong>
                      {createdByUsername}
                    </Typography.Text>
                  </Tooltip>
                </Col>
                <Col>
                  <Tooltip title={dateFormatter.shortDatetime(createdDate)}>
                    <Typography.Text type="secondary">
                      {formatCommentAge(createdDate, now)}
                    </Typography.Text>
                  </Tooltip>
                </Col>
              </Row>
              <Typography.Paragraph className="workflow-record-comment-text">
                {text}
              </Typography.Paragraph>
            </List.Item>
          )}
          split={false}
        />
      )}
      {canCreate && rowCreate && (
        <CommentForm
          fieldId={fieldId}
          name={name}
          onCommentAdded={onCommentAdded}
          recordId={recordId}
          rowCreate={rowCreate}
        />
      )}
    </div>
  )
}
